function load_data() {
  return {
    title: "Malaysia",
    version: "2.1.0",
    type: "FeatureCollection",
    copyright:
      "Copyright (c) 2023 Highsoft AS, Based on data from Natural Earth",
    copyrightShort: "Natural Earth",
    copyrightUrl: "http://www.naturalearthdata.com",
    crs: {
      type: "name",
      properties: {
        name: "urn:ogc:def:crs:EPSG:32650",
      },
    },
    "hc-transform": {
      default: {
        xpan: 380,
        crs: "+proj=utm +zone=50 +datum=WGS84 +units=m +no_defs",
        scale: 0.000552812495992,
        jsonres: 15.5,
        jsonmarginX: -999,
        jsonmarginY: 9851,
        xoffset: -333324.757457,
        yoffset: 813086.928782,
      },
      "my-all-west": {
        ypan: 40,
        hitZone: {
          type: "Polygon",
          coordinates: [
            [
              [-4200, 9999],
              [4350, 9999],
              [4350, -999],
              [-4200, -999],
              [-4200, 9999],
            ],
          ],
        },
        crs: "+proj=utm +zone=48 +datum=WGS84 +units=m +no_defs",
        scale: 0.000579843319192,
        jsonres: 15.5,
        jsonmarginX: -999,
        jsonmarginY: 9851,
        xoffset: -92969.6603627,
        yoffset: 744082.209002,
      },
    },
    features: [
      {
        type: "Feature",
        id: "MY.SA",
        properties: {
          "hc-group": "admin1",
          "hc-middle-x": 0.32,
          "hc-middle-y": 0.6,
          hc_key: "my-sa",
          "hc-a2": "SA",
          labelrank: "6",
          hasc: "MY.SA",
          "alt-name": "North Borneo",
          "woe-id": "2346310",
          subregion: null,
          fips: "MY16",
          "postal-code": "SA",
          name: "Sabah",
          country: "Malaysia",
          "type-en": "State",
          region: null,
          longitude: "117.095",
          "woe-name": "Sabah",
          latitude: "5.31115",
          "woe-label": "Sabah, MY, Malaysia",
          type: "State",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [13630, 7088],
                [13594, 7143],
                [13624, 7146],
                [13694, 7134],
                [13701, 7107],
                [13644, 7101],
                [13630, 7088],
              ],
            ],
            [
              [
                [13451, 7301],
                [13467, 7289],
                [13504, 7304],
                [13552, 7283],
                [13529, 7268],
                [13526, 7243],
                [13503, 7263],
                [13491, 7243],
                [13409, 7282],
                [13311, 7308],
                [13386, 7314],
                [13434, 7331],
                [13451, 7301],
              ],
            ],
            [
              [
                [13166, 8398],
                [13137, 8405],
                [13163, 8430],
                [13201, 8427],
                [13199, 8409],
                [13166, 8398],
              ],
            ],
            [
              [
                [12451, 9169],
                [12393, 9172],
                [12360, 9187],
                [12378, 9214],
                [12426, 9216],
                [12452, 9229],
                [12447, 9253],
                [12414, 9254],
                [12421, 9279],
                [12475, 9293],
                [12515, 9234],
                [12511, 9205],
                [12451, 9169],
              ],
            ],
            [
              [
                [12053, 9816],
                [12041, 9779],
                [12023, 9795],
                [12004, 9771],
                [12015, 9754],
                [11924, 9731],
                [11942, 9712],
                [11915, 9696],
                [11891, 9702],
                [11937, 9786],
                [11995, 9806],
                [12034, 9851],
                [12053, 9816],
              ],
            ],
            [
              [
                [12280, 9705],
                [12176, 9678],
                [12125, 9650],
                [12099, 9611],
                [12085, 9706],
                [12092, 9770],
                [12181, 9837],
                [12264, 9851],
                [12287, 9844],
                [12299, 9807],
                [12280, 9705],
              ],
            ],
            [
              [
                [12894, 6821],
                [12733, 6822],
                [12701, 6827],
                [12644, 6877],
                [12664, 6912],
                [12699, 6926],
                [12778, 6906],
                [12817, 6862],
                [12884, 6845],
                [12894, 6821],
              ],
            ],
            [
              [
                [10532, 7586],
                [10587, 7646],
                [10637, 7663],
                [10661, 7685],
                [10675, 7773],
                [10707, 7822],
                [10665, 7818],
                [10597, 7832],
                [10513, 7906],
                [10502, 7931],
                [10474, 7924],
                [10489, 7983],
                [10517, 8023],
                [10566, 8052],
                [10588, 8085],
                [10655, 8133],
                [10689, 8205],
                [10707, 8223],
                [10721, 8202],
                [10688, 8141],
                [10707, 8113],
                [10721, 8159],
                [10773, 8122],
                [10857, 8116],
                [10909, 8126],
                [10939, 8151],
                [10982, 8230],
                [11007, 8328],
                [11031, 8354],
                [11116, 8402],
                [11131, 8418],
                [11146, 8502],
                [11204, 8596],
                [11218, 8637],
                [11203, 8665],
                [11182, 8657],
                [11184, 8687],
                [11229, 8707],
                [11274, 8774],
                [11323, 8800],
                [11360, 8787],
                [11361, 8828],
                [11307, 8825],
                [11352, 8858],
                [11387, 8864],
                [11413, 8927],
                [11561, 9036],
                [11577, 9106],
                [11607, 9124],
                [11695, 9246],
                [11697, 9312],
                [11717, 9345],
                [11718, 9397],
                [11753, 9424],
                [11765, 9491],
                [11821, 9539],
                [11833, 9514],
                [11872, 9489],
                [11891, 9410],
                [11863, 9423],
                [11852, 9384],
                [11892, 9361],
                [11898, 9341],
                [11884, 9279],
                [11852, 9234],
                [11822, 9160],
                [11827, 9127],
                [11865, 9118],
                [12007, 9237],
                [12016, 9282],
                [12086, 9368],
                [12059, 9429],
                [12068, 9460],
                [12096, 9455],
                [12106, 9507],
                [12145, 9500],
                [12168, 9517],
                [12216, 9497],
                [12274, 9455],
                [12269, 9393],
                [12248, 9361],
                [12255, 9325],
                [12289, 9281],
                [12297, 9205],
                [12324, 9162],
                [12377, 9159],
                [12450, 9091],
                [12492, 9100],
                [12537, 9155],
                [12541, 9115],
                [12560, 9079],
                [12615, 9053],
                [12639, 9061],
                [12690, 8995],
                [12720, 8995],
                [12736, 8937],
                [12722, 8910],
                [12732, 8885],
                [12717, 8808],
                [12671, 8812],
                [12636, 8795],
                [12601, 8754],
                [12662, 8643],
                [12635, 8616],
                [12638, 8589],
                [12671, 8557],
                [12619, 8508],
                [12499, 8467],
                [12476, 8442],
                [12571, 8475],
                [12702, 8483],
                [12766, 8480],
                [12763, 8514],
                [12870, 8524],
                [12924, 8573],
                [12955, 8613],
                [12996, 8625],
                [13047, 8556],
                [13053, 8503],
                [13099, 8439],
                [13071, 8401],
                [13036, 8387],
                [12921, 8392],
                [12893, 8363],
                [12906, 8351],
                [12935, 8278],
                [12947, 8270],
                [13016, 8297],
                [13081, 8295],
                [13107, 8274],
                [13139, 8345],
                [13133, 8372],
                [13229, 8405],
                [13303, 8373],
                [13327, 8392],
                [13370, 8375],
                [13467, 8319],
                [13544, 8268],
                [13529, 8234],
                [13511, 8139],
                [13524, 8120],
                [13551, 8172],
                [13553, 8208],
                [13577, 8225],
                [13617, 8212],
                [13680, 8141],
                [13740, 8117],
                [13759, 8075],
                [13771, 8101],
                [13816, 8067],
                [13853, 8053],
                [13881, 7991],
                [13908, 7997],
                [13903, 8028],
                [13938, 8036],
                [13983, 8012],
                [14012, 8011],
                [14086, 8047],
                [14125, 8043],
                [14191, 7966],
                [14182, 7882],
                [14185, 7814],
                [14117, 7745],
                [14079, 7724],
                [13906, 7660],
                [13729, 7609],
                [13695, 7588],
                [13629, 7569],
                [13537, 7595],
                [13514, 7590],
                [13465, 7556],
                [13444, 7565],
                [13388, 7639],
                [13321, 7658],
                [13258, 7600],
                [13221, 7608],
                [13188, 7588],
                [13111, 7509],
                [13110, 7487],
                [13144, 7466],
                [13190, 7390],
                [13246, 7332],
                [13299, 7291],
                [13336, 7285],
                [13360, 7253],
                [13389, 7237],
                [13405, 7256],
                [13435, 7243],
                [13447, 7219],
                [13428, 7183],
                [13462, 7150],
                [13507, 7179],
                [13552, 7166],
                [13547, 7153],
                [13596, 7095],
                [13578, 7071],
                [13545, 7080],
                [13546, 7050],
                [13498, 7015],
                [13445, 7014],
                [13355, 7002],
                [13318, 7016],
                [13298, 6995],
                [13212, 6970],
                [13113, 6956],
                [12987, 6892],
                [12880, 6916],
                [12810, 6967],
                [12800, 6989],
                [12725, 7009],
                [12704, 7023],
                [12669, 7076],
                [12607, 7034],
                [12634, 7005],
                [12634, 6966],
                [12651, 6942],
                [12640, 6911],
                [12601, 6869],
                [12628, 6840],
                [12571, 6824],
                [12547, 6837],
                [12505, 6836],
                [12446, 6848],
                [12370, 6918],
                [12293, 6958],
                [12238, 7007],
                [12188, 6988],
                [12013, 6985],
                [11959, 6999],
                [11846, 6985],
                [11757, 7020],
                [11727, 6994],
                [11666, 6998],
                [11629, 6987],
                [11588, 7047],
                [11543, 7003],
                [11550, 6980],
                [11505, 6973],
                [11482, 6949],
                [11452, 6952],
                [11415, 7012],
                [11376, 7036],
                [11298, 7010],
                [11200, 7032],
                [11185, 7000],
                [11100, 6930],
                [11074, 6947],
                [11065, 6977],
                [11024, 6999],
                [10965, 7007],
                [10932, 7042],
                [10911, 6999],
                [10907, 6940],
                [10849, 6884],
                [10826, 6900],
                [10737, 6812],
                [10725, 6847],
                [10731, 6894],
                [10759, 6931],
                [10772, 6969],
                [10734, 7022],
                [10697, 7034],
                [10682, 7107],
                [10663, 7144],
                [10662, 7230],
                [10694, 7283],
                [10713, 7370],
                [10732, 7388],
                [10757, 7455],
                [10736, 7565],
                [10723, 7581],
                [10620, 7576],
                [10532, 7586],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "MY.SK",
        properties: {
          "hc-group": "admin1",
          "hc-middle-x": 0.75,
          "hc-middle-y": 0.46,
          hc_key: "my-sk",
          "hc-a2": "SK",
          labelrank: "6",
          hasc: "MY.SK",
          "alt-name": null,
          "woe-id": "2346305",
          subregion: null,
          fips: "MY11",
          "postal-code": "SK",
          name: "Sarawak",
          country: "Malaysia",
          "type-en": "State",
          region: null,
          longitude: "113.344",
          "woe-name": "Sarawak",
          latitude: "2.44952",
          "woe-label": "Sarawak, MY, Malaysia",
          type: "State",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [6700, 5156],
                [6659, 5130],
                [6633, 5181],
                [6600, 5218],
                [6610, 5298],
                [6593, 5456],
                [6595, 5504],
                [6609, 5534],
                [6642, 5522],
                [6671, 5452],
                [6671, 5285],
                [6679, 5215],
                [6700, 5156],
              ],
            ],
            [
              [
                [10532, 7586],
                [10620, 7576],
                [10723, 7581],
                [10736, 7565],
                [10757, 7455],
                [10732, 7388],
                [10713, 7370],
                [10694, 7283],
                [10662, 7230],
                [10663, 7144],
                [10682, 7107],
                [10697, 7034],
                [10734, 7022],
                [10772, 6969],
                [10759, 6931],
                [10731, 6894],
                [10725, 6847],
                [10737, 6812],
                [10709, 6671],
                [10681, 6623],
                [10641, 6598],
                [10641, 6577],
                [10689, 6539],
                [10689, 6507],
                [10652, 6397],
                [10650, 6300],
                [10674, 6243],
                [10673, 6204],
                [10699, 6144],
                [10685, 6121],
                [10658, 6129],
                [10620, 6065],
                [10587, 5922],
                [10619, 5875],
                [10586, 5831],
                [10569, 5756],
                [10514, 5745],
                [10422, 5713],
                [10357, 5766],
                [10314, 5696],
                [10259, 5659],
                [10221, 5594],
                [10190, 5564],
                [10226, 5501],
                [10186, 5465],
                [10195, 5416],
                [10180, 5356],
                [10205, 5342],
                [10236, 5355],
                [10280, 5339],
                [10309, 5301],
                [10322, 5262],
                [10310, 5244],
                [10246, 5233],
                [10190, 5180],
                [10100, 5118],
                [10063, 5121],
                [10045, 5094],
                [10049, 5060],
                [10017, 5040],
                [9944, 5030],
                [9915, 5014],
                [9889, 4925],
                [9916, 4814],
                [9965, 4822],
                [9978, 4803],
                [9963, 4741],
                [9965, 4687],
                [9899, 4655],
                [9848, 4649],
                [9812, 4610],
                [9820, 4555],
                [9809, 4490],
                [9767, 4399],
                [9708, 4340],
                [9713, 4277],
                [9691, 4244],
                [9648, 4245],
                [9551, 4309],
                [9510, 4308],
                [9366, 4248],
                [9324, 4235],
                [9296, 4263],
                [9222, 4273],
                [9084, 4252],
                [9045, 4227],
                [8987, 4155],
                [8836, 4054],
                [8785, 4062],
                [8737, 4119],
                [8696, 4131],
                [8639, 4110],
                [8595, 4112],
                [8525, 4167],
                [8479, 4183],
                [8367, 4202],
                [8301, 4243],
                [8264, 4246],
                [8176, 4228],
                [8179, 4246],
                [8233, 4301],
                [8238, 4343],
                [8190, 4374],
                [8128, 4375],
                [8077, 4387],
                [8026, 4350],
                [7995, 4358],
                [7710, 4373],
                [7641, 4331],
                [7542, 4313],
                [7432, 4261],
                [7412, 4215],
                [7435, 4185],
                [7405, 4126],
                [7355, 3982],
                [7311, 3962],
                [7233, 3962],
                [7173, 3943],
                [7089, 3843],
                [7032, 3828],
                [6929, 3865],
                [6898, 3864],
                [6817, 3833],
                [6783, 3796],
                [6763, 3848],
                [6736, 3857],
                [6680, 3842],
                [6638, 3849],
                [6510, 3906],
                [6490, 3908],
                [6275, 3853],
                [6215, 3851],
                [6160, 3834],
                [6106, 3789],
                [6094, 3749],
                [6017, 3743],
                [5963, 3717],
                [5930, 3736],
                [5873, 3695],
                [5827, 3701],
                [5747, 3751],
                [5707, 3806],
                [5679, 3825],
                [5594, 3832],
                [5588, 3875],
                [5505, 4004],
                [5432, 4021],
                [5392, 4044],
                [5371, 4080],
                [5319, 4113],
                [5296, 4143],
                [5278, 4200],
                [5248, 4224],
                [5191, 4224],
                [5151, 4284],
                [5127, 4276],
                [5118, 4313],
                [5033, 4386],
                [4999, 4447],
                [5005, 4567],
                [5000, 4585],
                [4940, 4592],
                [4908, 4617],
                [4891, 4689],
                [4900, 4716],
                [4935, 4745],
                [4986, 4822],
                [5004, 4873],
                [5021, 4778],
                [5012, 4734],
                [5049, 4673],
                [5086, 4640],
                [5145, 4615],
                [5235, 4564],
                [5274, 4499],
                [5335, 4497],
                [5382, 4509],
                [5504, 4507],
                [5546, 4488],
                [5587, 4511],
                [5622, 4480],
                [5638, 4520],
                [5633, 4573],
                [5673, 4598],
                [5695, 4520],
                [5748, 4501],
                [5769, 4523],
                [5831, 4543],
                [5843, 4526],
                [5813, 4457],
                [5790, 4429],
                [5843, 4435],
                [5858, 4406],
                [5921, 4410],
                [6040, 4358],
                [6046, 4312],
                [5993, 4271],
                [6038, 4269],
                [6085, 4312],
                [6078, 4362],
                [6104, 4382],
                [6148, 4376],
                [6230, 4342],
                [6271, 4316],
                [6344, 4243],
                [6450, 4186],
                [6525, 4212],
                [6628, 4153],
                [6669, 4172],
                [6614, 4185],
                [6601, 4218],
                [6552, 4236],
                [6492, 4218],
                [6453, 4223],
                [6407, 4260],
                [6348, 4290],
                [6309, 4365],
                [6309, 4401],
                [6339, 4481],
                [6394, 4491],
                [6434, 4485],
                [6474, 4433],
                [6513, 4456],
                [6468, 4464],
                [6451, 4499],
                [6427, 4504],
                [6395, 4574],
                [6426, 4596],
                [6408, 4613],
                [6420, 4649],
                [6471, 4743],
                [6506, 4858],
                [6560, 4852],
                [6536, 4873],
                [6547, 4908],
                [6618, 4893],
                [6663, 4934],
                [6657, 4949],
                [6628, 4912],
                [6563, 4934],
                [6481, 4926],
                [6475, 4958],
                [6496, 4989],
                [6534, 4994],
                [6482, 5030],
                [6505, 5158],
                [6541, 5203],
                [6594, 5169],
                [6655, 5112],
                [6734, 5142],
                [6777, 5116],
                [6711, 5194],
                [6693, 5248],
                [6772, 5238],
                [6805, 5254],
                [6748, 5271],
                [6711, 5301],
                [6706, 5339],
                [6728, 5434],
                [6745, 5459],
                [6814, 5511],
                [6948, 5588],
                [7131, 5623],
                [7277, 5628],
                [7814, 5766],
                [7960, 5796],
                [8196, 5869],
                [8228, 5886],
                [8279, 5940],
                [8299, 5976],
                [8287, 5997],
                [8380, 6076],
                [8412, 6126],
                [8486, 6191],
                [8516, 6262],
                [8595, 6346],
                [8618, 6384],
                [8637, 6446],
                [8694, 6482],
                [8926, 6680],
                [9127, 6938],
                [9147, 6983],
                [9140, 7021],
                [9161, 7052],
                [9171, 7137],
                [9150, 7226],
                [9178, 7248],
                [9240, 7218],
                [9292, 7210],
                [9412, 7133],
                [9434, 7092],
                [9460, 6977],
                [9447, 6928],
                [9521, 6917],
                [9577, 6923],
                [9632, 6814],
                [9719, 6737],
                [9735, 6696],
                [9774, 6691],
                [9819, 6717],
                [9907, 6800],
                [9927, 6872],
                [9955, 6921],
                [9922, 6945],
                [9974, 7014],
                [9985, 7077],
                [9945, 7086],
                [9923, 7147],
                [9918, 7258],
                [9885, 7351],
                [9895, 7375],
                [10015, 7445],
                [10082, 7451],
                [10092, 7496],
                [10146, 7543],
                [10159, 7452],
                [10152, 7377],
                [10164, 7263],
                [10206, 7152],
                [10217, 7059],
                [10237, 7037],
                [10311, 7012],
                [10340, 7015],
                [10438, 6972],
                [10473, 6986],
                [10457, 7026],
                [10401, 7087],
                [10389, 7124],
                [10384, 7201],
                [10390, 7278],
                [10328, 7457],
                [10271, 7514],
                [10270, 7535],
                [10311, 7544],
                [10320, 7575],
                [10344, 7582],
                [10363, 7561],
                [10410, 7551],
                [10420, 7533],
                [10472, 7529],
                [10532, 7586],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "MY.LA",
        properties: {
          "hc-group": "admin1",
          "hc-middle-x": 0.42,
          "hc-middle-y": 0.5,
          hc_key: "my-la",
          "hc-a2": "LA",
          labelrank: "6",
          hasc: "MY.LA",
          "alt-name": "North Borneo",
          "woe-id": "2346309",
          subregion: null,
          fips: "MY15",
          "postal-code": "LA",
          name: "Labuan",
          country: "Malaysia",
          "type-en": "Federal Territory",
          region: null,
          longitude: "115.222",
          "woe-name": "Labuan",
          latitude: "5.32524",
          "woe-label": "Labuan, MY, Malaysia",
          type: "Federal Territory",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [10378, 7898],
              [10362, 7880],
              [10334, 7892],
              [10283, 7861],
              [10312, 7949],
              [10362, 7989],
              [10378, 7898],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "MY.PG",
        properties: {
          "hc-group": "admin1",
          "hc-middle-x": 0.73,
          "hc-middle-y": 0.38,
          hc_key: "my-pg",
          "hc-a2": "PG",
          labelrank: "6",
          hasc: "MY.PG",
          "alt-name": "Penang and Province Wellesley|Penang",
          "woe-id": "2346304",
          subregion: null,
          fips: "MY09",
          "postal-code": "PG",
          name: "Pulau Pinang",
          country: "Malaysia",
          "type-en": "State",
          region: null,
          longitude: "100.261",
          "woe-name": "Pulau Pinang",
          latitude: "5.36839",
          "woe-label": "Pulau Pinang, MY, Malaysia",
          type: "State",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [-344, 7977],
                [-311, 7943],
                [-329, 7909],
                [-338, 7853],
                [-367, 7789],
                [-476, 7805],
                [-459, 7827],
                [-461, 7926],
                [-475, 7954],
                [-462, 7990],
                [-436, 7973],
                [-419, 7991],
                [-380, 7995],
                [-344, 7977],
              ],
            ],
            [
              [
                [-253, 7646],
                [-225, 7716],
                [-237, 7774],
                [-225, 7828],
                [-270, 7902],
                [-276, 7939],
                [-269, 8024],
                [-299, 8094],
                [-153, 8084],
                [-120, 8074],
                [-129, 7993],
                [-113, 7788],
                [-98, 7672],
                [-122, 7654],
                [-153, 7660],
                [-176, 7663],
                [-253, 7646],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "MY.KH",
        properties: {
          "hc-group": "admin1",
          "hc-middle-x": 0.72,
          "hc-middle-y": 0.39,
          hc_key: "my-kh",
          "hc-a2": "KH",
          labelrank: "6",
          hasc: "MY.KH",
          "alt-name": "Kedah Darul Aman",
          "woe-id": "2346297",
          subregion: null,
          fips: "MY02",
          "postal-code": "KH",
          name: "Kedah",
          country: "Malaysia",
          "type-en": "State",
          region: null,
          longitude: "100.647",
          "woe-name": "Kedah",
          latitude: "5.80958",
          "woe-label": "Kedah, MY, Malaysia",
          type: "State",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [-732, 8917],
                [-745, 8891],
                [-730, 8858],
                [-797, 8828],
                [-801, 8852],
                [-838, 8845],
                [-868, 8811],
                [-917, 8790],
                [-930, 8839],
                [-926, 8882],
                [-986, 8892],
                [-999, 8924],
                [-999, 8965],
                [-975, 8956],
                [-923, 8963],
                [-908, 8952],
                [-859, 8951],
                [-830, 8982],
                [-793, 8993],
                [-778, 8957],
                [-732, 8917],
              ],
            ],
            [
              [
                [-806, 8805],
                [-822, 8786],
                [-817, 8734],
                [-842, 8700],
                [-879, 8752],
                [-846, 8801],
                [-809, 8822],
                [-806, 8805],
              ],
            ],
            [
              [
                [-299, 8094],
                [-308, 8194],
                [-288, 8187],
                [-266, 8204],
                [-288, 8219],
                [-276, 8335],
                [-301, 8536],
                [-335, 8594],
                [-353, 8639],
                [-388, 8705],
                [-400, 8745],
                [-448, 8785],
                [-432, 8823],
                [-321, 8946],
                [-280, 8978],
                [-268, 9049],
                [-236, 9037],
                [-178, 9034],
                [-129, 9003],
                [-34, 8969],
                [2, 8967],
                [66, 9012],
                [83, 9012],
                [95, 8969],
                [126, 8966],
                [158, 8933],
                [160, 8886],
                [181, 8835],
                [173, 8779],
                [184, 8756],
                [206, 8767],
                [261, 8754],
                [306, 8787],
                [325, 8790],
                [373, 8758],
                [432, 8763],
                [439, 8706],
                [403, 8675],
                [402, 8652],
                [436, 8623],
                [443, 8603],
                [436, 8508],
                [419, 8438],
                [363, 8417],
                [312, 8312],
                [319, 8293],
                [302, 8286],
                [331, 8242],
                [316, 8179],
                [278, 8141],
                [295, 8106],
                [292, 8072],
                [263, 8021],
                [244, 8023],
                [219, 7986],
                [206, 7894],
                [184, 7862],
                [107, 7844],
                [87, 7806],
                [47, 7772],
                [30, 7731],
                [-41, 7669],
                [-51, 7646],
                [-100, 7606],
                [-139, 7625],
                [-153, 7660],
                [-122, 7654],
                [-98, 7672],
                [-113, 7788],
                [-129, 7993],
                [-120, 8074],
                [-153, 8084],
                [-299, 8094],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "MY.SL",
        properties: {
          "hc-group": "admin1",
          "hc-middle-x": 0.68,
          "hc-middle-y": 0.39,
          hc_key: "my-sl",
          "hc-a2": "SL",
          labelrank: "6",
          hasc: "MY.SL",
          "alt-name": "Selangor Darul Ehsan",
          "woe-id": "2346306",
          subregion: null,
          fips: "MY12",
          "postal-code": "SL",
          name: "Selangor",
          country: "Malaysia",
          "type-en": "State",
          region: null,
          longitude: "101.428",
          "woe-name": "Selangor",
          latitude: "3.3078",
          "woe-label": "Selangor, MY, Malaysia",
          type: "State",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [592, 5560],
                [576, 5556],
                [577, 5579],
                [604, 5576],
                [592, 5560],
              ],
            ],
            [
              [
                [608, 5498],
                [600, 5512],
                [639, 5594],
                [669, 5595],
                [668, 5539],
                [608, 5498],
              ],
            ],
            [
              [
                [1053, 5126],
                [1005, 5158],
                [950, 5168],
                [874, 5192],
                [834, 5220],
                [762, 5323],
                [731, 5350],
                [643, 5364],
                [618, 5380],
                [636, 5425],
                [615, 5442],
                [665, 5502],
                [705, 5532],
                [698, 5606],
                [656, 5654],
                [631, 5803],
                [582, 5849],
                [569, 5873],
                [531, 5888],
                [474, 5971],
                [443, 6003],
                [409, 6063],
                [392, 6129],
                [375, 6150],
                [263, 6225],
                [222, 6285],
                [148, 6315],
                [159, 6356],
                [176, 6371],
                [278, 6387],
                [281, 6359],
                [312, 6334],
                [312, 6299],
                [333, 6322],
                [359, 6326],
                [396, 6309],
                [399, 6280],
                [428, 6304],
                [438, 6276],
                [415, 6260],
                [445, 6261],
                [462, 6279],
                [507, 6244],
                [536, 6249],
                [554, 6236],
                [585, 6238],
                [591, 6200],
                [651, 6204],
                [682, 6230],
                [660, 6293],
                [684, 6319],
                [716, 6315],
                [728, 6295],
                [775, 6275],
                [799, 6240],
                [860, 6203],
                [899, 6235],
                [944, 6292],
                [962, 6297],
                [990, 6253],
                [1026, 6229],
                [1067, 6219],
                [1101, 6199],
                [1148, 6123],
                [1142, 6084],
                [1121, 6067],
                [1099, 6019],
                [1119, 5942],
                [1099, 5900],
                [1164, 5816],
                [1218, 5792],
                [1250, 5787],
                [1263, 5781],
                [1280, 5741],
                [1277, 5714],
                [1295, 5662],
                [1289, 5617],
                [1297, 5565],
                [1272, 5539],
                [1264, 5494],
                [1233, 5463],
                [1221, 5410],
                [1193, 5387],
                [1116, 5395],
                [1092, 5392],
                [1105, 5268],
                [1070, 5197],
                [1053, 5126],
              ],
              [
                [1003, 5564],
                [1043, 5567],
                [1064, 5558],
                [1085, 5586],
                [1076, 5661],
                [1096, 5704],
                [1072, 5743],
                [1042, 5735],
                [999, 5759],
                [976, 5745],
                [956, 5710],
                [958, 5672],
                [984, 5646],
                [999, 5611],
                [989, 5586],
                [1003, 5564],
              ],
              [
                [1009, 5405],
                [1035, 5418],
                [1063, 5458],
                [1046, 5510],
                [1006, 5495],
                [1009, 5405],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "MY.PH",
        properties: {
          "hc-group": "admin1",
          "hc-middle-x": 0.39,
          "hc-middle-y": 0.39,
          hc_key: "my-ph",
          "hc-a2": "PH",
          labelrank: "6",
          hasc: "MY.PH",
          "alt-name": "Pahang Darul Makmur",
          "woe-id": "2346301",
          subregion: null,
          fips: "MY06",
          "postal-code": "PH",
          name: "Pahang",
          country: "Malaysia",
          "type-en": "State",
          region: null,
          longitude: "102.491",
          "woe-name": "Pahang",
          latitude: "3.84557",
          "woe-label": "Pahang, MY, Malaysia",
          type: "State",
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [3457, 5303],
                [3492, 5343],
                [3485, 5389],
                [3502, 5416],
                [3517, 5410],
                [3554, 5311],
                [3556, 5262],
                [3542, 5241],
                [3489, 5239],
                [3462, 5272],
                [3457, 5303],
              ],
            ],
            [
              [
                [2777, 6687],
                [2729, 6634],
                [2735, 6586],
                [2772, 6494],
                [2768, 6469],
                [2745, 6483],
                [2718, 6410],
                [2712, 6322],
                [2695, 6322],
                [2672, 6279],
                [2678, 6242],
                [2738, 6121],
                [2795, 6056],
                [2781, 6027],
                [2815, 6033],
                [2766, 5931],
                [2761, 5890],
                [2777, 5767],
                [2788, 5727],
                [2767, 5487],
                [2773, 5447],
                [2806, 5377],
                [2852, 5315],
                [2972, 5198],
                [2932, 5155],
                [2955, 5132],
                [2942, 5105],
                [2936, 5054],
                [2966, 5029],
                [2965, 5004],
                [2941, 4977],
                [2799, 5062],
                [2778, 5085],
                [2696, 5121],
                [2640, 5113],
                [2490, 5058],
                [2324, 5123],
                [2288, 5152],
                [2147, 5322],
                [2037, 5366],
                [2020, 5423],
                [2001, 5419],
                [1799, 5556],
                [1722, 5644],
                [1638, 5658],
                [1513, 5699],
                [1458, 5721],
                [1399, 5700],
                [1390, 5740],
                [1343, 5752],
                [1267, 5810],
                [1250, 5787],
                [1218, 5792],
                [1164, 5816],
                [1099, 5900],
                [1119, 5942],
                [1099, 6019],
                [1121, 6067],
                [1142, 6084],
                [1148, 6123],
                [1101, 6199],
                [1067, 6219],
                [1026, 6229],
                [990, 6253],
                [962, 6297],
                [937, 6318],
                [937, 6392],
                [916, 6431],
                [911, 6504],
                [897, 6529],
                [922, 6606],
                [876, 6655],
                [859, 6651],
                [846, 6695],
                [849, 6724],
                [805, 6741],
                [805, 6780],
                [792, 6801],
                [790, 6842],
                [771, 6867],
                [781, 6908],
                [704, 6930],
                [680, 6955],
                [724, 7019],
                [708, 7053],
                [704, 7097],
                [718, 7135],
                [770, 7120],
                [800, 7095],
                [827, 7112],
                [880, 7117],
                [931, 7082],
                [958, 7077],
                [999, 7089],
                [1066, 7143],
                [1109, 7162],
                [1116, 7257],
                [1128, 7280],
                [1157, 7274],
                [1160, 7246],
                [1226, 7195],
                [1240, 7143],
                [1283, 7193],
                [1303, 7279],
                [1340, 7282],
                [1392, 7253],
                [1455, 7277],
                [1470, 7237],
                [1506, 7210],
                [1538, 7162],
                [1621, 7180],
                [1681, 7163],
                [1710, 7202],
                [1710, 7221],
                [1741, 7236],
                [1788, 7229],
                [1827, 7197],
                [1854, 7193],
                [1886, 7224],
                [1936, 7210],
                [1936, 7258],
                [1953, 7298],
                [1998, 7285],
                [2028, 7234],
                [2103, 7197],
                [2181, 7192],
                [2208, 7165],
                [2217, 7129],
                [2203, 7086],
                [2180, 7064],
                [2187, 7028],
                [2224, 6987],
                [2285, 6973],
                [2302, 6994],
                [2345, 6960],
                [2361, 6917],
                [2347, 6854],
                [2321, 6855],
                [2296, 6838],
                [2269, 6791],
                [2252, 6680],
                [2238, 6656],
                [2274, 6628],
                [2328, 6651],
                [2401, 6632],
                [2450, 6607],
                [2511, 6555],
                [2535, 6559],
                [2548, 6534],
                [2571, 6538],
                [2613, 6472],
                [2613, 6450],
                [2637, 6411],
                [2672, 6447],
                [2677, 6476],
                [2657, 6532],
                [2658, 6569],
                [2641, 6584],
                [2642, 6628],
                [2659, 6669],
                [2655, 6712],
                [2680, 6698],
                [2753, 6695],
                [2777, 6687],
              ],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "MY.KL",
        properties: {
          "hc-group": "admin1",
          "hc-middle-x": 0.47,
          "hc-middle-y": 0.5,
          hc_key: "my-kl",
          "hc-a2": "KL",
          labelrank: "6",
          hasc: "MY.KL",
          "alt-name": null,
          "woe-id": "56014685",
          subregion: null,
          fips: "MY14",
          "postal-code": "KL",
          name: "Kuala Lumpur",
          country: "Malaysia",
          "type-en": "Federal Territory",
          region: null,
          longitude: "101.698",
          "woe-name": "Kuala Lumpur",
          latitude: "3.13836",
          "woe-label": "Kuala Lumpur, MY, Malaysia",
          type: "Federal Territory",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [1003, 5564],
              [989, 5586],
              [999, 5611],
              [984, 5646],
              [958, 5672],
              [956, 5710],
              [976, 5745],
              [999, 5759],
              [1042, 5735],
              [1072, 5743],
              [1096, 5704],
              [1076, 5661],
              [1085, 5586],
              [1064, 5558],
              [1043, 5567],
              [1003, 5564],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "MY.PJ",
        properties: {
          "hc-group": "admin1",
          "hc-middle-x": 0.51,
          "hc-middle-y": 0.5,
          hc_key: "my-pj",
          "hc-a2": "PJ",
          labelrank: "6",
          hasc: "MY.PJ",
          "alt-name": null,
          "woe-id": "28350159",
          subregion: null,
          fips: "MY17",
          "postal-code": "PJ",
          name: "Putrajaya",
          country: "Malaysia",
          "type-en": "Federal Territory",
          region: null,
          longitude: "101.706",
          "woe-name": "Putrajaya",
          latitude: "2.93814",
          "woe-label": "Putrajaya, MY, Malaysia",
          type: "Federal Territory",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [1009, 5405],
              [1006, 5495],
              [1046, 5510],
              [1063, 5458],
              [1035, 5418],
              [1009, 5405],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "MY.PL",
        properties: {
          "hc-group": "admin1",
          "hc-middle-x": 0.53,
          "hc-middle-y": 0.41,
          hc_key: "my-pl",
          "hc-a2": "PL",
          labelrank: "6",
          hasc: "MY.PL",
          "alt-name": "Perlis Indra Kayangan",
          "woe-id": "2346303",
          subregion: null,
          fips: "MY08",
          "postal-code": "PL",
          name: "Perlis",
          country: "Malaysia",
          "type-en": "State",
          region: null,
          longitude: "100.253",
          "woe-name": "Perlis",
          latitude: "6.52169",
          "woe-label": "Perlis, MY, Malaysia",
          type: "State",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [-448, 8785],
              [-472, 8815],
              [-508, 8905],
              [-518, 8967],
              [-501, 9004],
              [-499, 9063],
              [-477, 9090],
              [-488, 9144],
              [-476, 9218],
              [-455, 9231],
              [-431, 9212],
              [-400, 9223],
              [-363, 9211],
              [-327, 9099],
              [-296, 9063],
              [-268, 9049],
              [-280, 8978],
              [-321, 8946],
              [-432, 8823],
              [-448, 8785],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "MY.JH",
        properties: {
          "hc-group": "admin1",
          "hc-middle-x": 0.56,
          "hc-middle-y": 0.54,
          hc_key: "my-jh",
          "hc-a2": "JH",
          labelrank: "7",
          hasc: "MY.JH",
          "alt-name": "Johor Darul Takzim|Johore",
          "woe-id": "2346296",
          subregion: null,
          fips: "MY01",
          "postal-code": "JH",
          name: "Johor",
          country: "Malaysia",
          "type-en": "State",
          region: null,
          longitude: "103.412",
          "woe-name": "Johor",
          latitude: "2.00649",
          "woe-label": "Johor, MY, Malaysia",
          type: "State",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [2972, 5198],
              [3017, 5189],
              [3057, 5170],
              [3097, 5176],
              [3099, 5151],
              [3145, 5109],
              [3171, 5052],
              [3162, 5010],
              [3169, 4992],
              [3243, 4899],
              [3280, 4868],
              [3287, 4827],
              [3315, 4783],
              [3300, 4742],
              [3307, 4722],
              [3354, 4664],
              [3380, 4602],
              [3452, 4485],
              [3450, 4422],
              [3466, 4380],
              [3498, 4379],
              [3526, 4331],
              [3535, 4285],
              [3559, 4244],
              [3560, 4211],
              [3586, 4171],
              [3594, 4105],
              [3615, 4051],
              [3625, 3981],
              [3610, 3961],
              [3608, 3902],
              [3570, 3902],
              [3550, 3881],
              [3485, 3887],
              [3437, 3910],
              [3431, 3953],
              [3395, 3983],
              [3390, 4019],
              [3454, 4051],
              [3478, 4079],
              [3442, 4079],
              [3384, 4040],
              [3343, 4130],
              [3297, 4181],
              [3301, 4142],
              [3339, 4082],
              [3334, 4041],
              [3340, 3983],
              [3305, 3954],
              [3257, 3966],
              [3170, 4011],
              [3145, 4009],
              [3084, 3983],
              [3043, 3986],
              [3012, 3976],
              [2961, 3912],
              [2931, 3888],
              [2895, 3895],
              [2878, 3917],
              [2882, 3878],
              [2847, 3806],
              [2799, 3855],
              [2777, 3894],
              [2744, 4002],
              [2726, 4041],
              [2698, 4072],
              [2656, 4099],
              [2537, 4144],
              [2368, 4249],
              [2327, 4268],
              [2265, 4281],
              [2194, 4361],
              [2135, 4393],
              [2053, 4380],
              [2030, 4392],
              [1981, 4473],
              [1900, 4538],
              [1888, 4577],
              [1820, 4625],
              [1837, 4652],
              [1862, 4655],
              [1867, 4702],
              [1819, 4721],
              [1813, 4743],
              [1833, 4765],
              [1834, 4802],
              [1853, 4855],
              [1851, 4880],
              [1886, 4927],
              [1931, 4951],
              [1952, 5014],
              [1954, 5099],
              [1974, 5137],
              [1966, 5162],
              [2032, 5336],
              [2037, 5366],
              [2147, 5322],
              [2288, 5152],
              [2324, 5123],
              [2490, 5058],
              [2640, 5113],
              [2696, 5121],
              [2778, 5085],
              [2799, 5062],
              [2941, 4977],
              [2965, 5004],
              [2966, 5029],
              [2936, 5054],
              [2942, 5105],
              [2955, 5132],
              [2932, 5155],
              [2972, 5198],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "MY.PK",
        properties: {
          "hc-group": "admin1",
          "hc-middle-x": 0.46,
          "hc-middle-y": 0.58,
          hc_key: "my-pk",
          "hc-a2": "PK",
          labelrank: "6",
          hasc: "MY.PK",
          "alt-name": "Perak Darul Ridzuan",
          "woe-id": "2346302",
          subregion: null,
          fips: "MY07",
          "postal-code": "PK",
          name: "Perak",
          country: "Malaysia",
          "type-en": "State",
          region: null,
          longitude: "101.059",
          "woe-name": "Perak",
          latitude: "4.74737",
          "woe-label": "Perak, MY, Malaysia",
          type: "State",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [176, 6371],
              [170, 6383],
              [120, 6368],
              [56, 6397],
              [37, 6446],
              [37, 6496],
              [55, 6519],
              [138, 6519],
              [154, 6539],
              [208, 6546],
              [198, 6568],
              [140, 6547],
              [114, 6549],
              [113, 6614],
              [103, 6628],
              [15, 6693],
              [-30, 6684],
              [-50, 6737],
              [-71, 6828],
              [-96, 6847],
              [-73, 6940],
              [-54, 6954],
              [-28, 7060],
              [-30, 7081],
              [-63, 7099],
              [-69, 7118],
              [-56, 7156],
              [-28, 7156],
              [6, 7196],
              [-56, 7192],
              [-65, 7269],
              [-27, 7284],
              [-47, 7298],
              [-42, 7319],
              [-83, 7325],
              [-81, 7380],
              [-108, 7402],
              [-164, 7399],
              [-144, 7429],
              [-176, 7451],
              [-204, 7436],
              [-231, 7491],
              [-256, 7519],
              [-285, 7588],
              [-291, 7619],
              [-253, 7646],
              [-176, 7663],
              [-153, 7660],
              [-139, 7625],
              [-100, 7606],
              [-51, 7646],
              [-41, 7669],
              [30, 7731],
              [47, 7772],
              [87, 7806],
              [107, 7844],
              [184, 7862],
              [206, 7894],
              [219, 7986],
              [244, 8023],
              [263, 8021],
              [292, 8072],
              [295, 8106],
              [278, 8141],
              [316, 8179],
              [331, 8242],
              [302, 8286],
              [319, 8293],
              [338, 8257],
              [384, 8244],
              [425, 8207],
              [451, 8157],
              [496, 8158],
              [543, 8186],
              [571, 8218],
              [595, 8305],
              [665, 8327],
              [739, 8368],
              [881, 8421],
              [925, 8422],
              [951, 8381],
              [980, 8371],
              [976, 8344],
              [1011, 8281],
              [1042, 8282],
              [1039, 8210],
              [1012, 8185],
              [1012, 8129],
              [1031, 8086],
              [1014, 8035],
              [1085, 8026],
              [1096, 8002],
              [1090, 7879],
              [1016, 7852],
              [963, 7878],
              [924, 7846],
              [894, 7794],
              [875, 7793],
              [858, 7733],
              [839, 7704],
              [833, 7645],
              [811, 7582],
              [798, 7515],
              [776, 7495],
              [797, 7461],
              [804, 7421],
              [792, 7380],
              [751, 7352],
              [758, 7311],
              [727, 7276],
              [725, 7228],
              [695, 7223],
              [683, 7204],
              [718, 7135],
              [704, 7097],
              [708, 7053],
              [724, 7019],
              [680, 6955],
              [704, 6930],
              [781, 6908],
              [771, 6867],
              [790, 6842],
              [792, 6801],
              [805, 6780],
              [805, 6741],
              [849, 6724],
              [846, 6695],
              [859, 6651],
              [876, 6655],
              [922, 6606],
              [897, 6529],
              [911, 6504],
              [916, 6431],
              [937, 6392],
              [937, 6318],
              [962, 6297],
              [944, 6292],
              [899, 6235],
              [860, 6203],
              [799, 6240],
              [775, 6275],
              [728, 6295],
              [716, 6315],
              [684, 6319],
              [660, 6293],
              [682, 6230],
              [651, 6204],
              [591, 6200],
              [585, 6238],
              [554, 6236],
              [536, 6249],
              [507, 6244],
              [462, 6279],
              [445, 6261],
              [415, 6260],
              [438, 6276],
              [428, 6304],
              [399, 6280],
              [396, 6309],
              [359, 6326],
              [333, 6322],
              [312, 6299],
              [312, 6334],
              [281, 6359],
              [278, 6387],
              [176, 6371],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "MY.KN",
        properties: {
          "hc-group": "admin1",
          "hc-middle-x": 0.48,
          "hc-middle-y": 0.57,
          hc_key: "my-kn",
          "hc-a2": "KN",
          labelrank: "6",
          hasc: "MY.KN",
          "alt-name": null,
          "woe-id": "2346298",
          subregion: null,
          fips: "MY03",
          "postal-code": "KN",
          name: "Kelantan",
          country: "Malaysia",
          "type-en": "State",
          region: null,
          longitude: "102.005",
          "woe-name": "Kelantan",
          latitude: "5.40349",
          "woe-label": "Kelantan, MY, Malaysia",
          type: "State",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [718, 7135],
              [683, 7204],
              [695, 7223],
              [725, 7228],
              [727, 7276],
              [758, 7311],
              [751, 7352],
              [792, 7380],
              [804, 7421],
              [797, 7461],
              [776, 7495],
              [798, 7515],
              [811, 7582],
              [833, 7645],
              [839, 7704],
              [858, 7733],
              [875, 7793],
              [894, 7794],
              [924, 7846],
              [963, 7878],
              [1016, 7852],
              [1090, 7879],
              [1096, 8002],
              [1085, 8026],
              [1014, 8035],
              [1031, 8086],
              [1012, 8129],
              [1012, 8185],
              [1039, 8210],
              [1042, 8282],
              [1085, 8297],
              [1107, 8264],
              [1145, 8255],
              [1170, 8294],
              [1199, 8312],
              [1214, 8338],
              [1258, 8373],
              [1265, 8453],
              [1280, 8494],
              [1305, 8524],
              [1379, 8580],
              [1405, 8606],
              [1417, 8638],
              [1413, 8716],
              [1419, 8768],
              [1509, 8708],
              [1532, 8714],
              [1524, 8744],
              [1545, 8743],
              [1660, 8700],
              [1724, 8643],
              [1842, 8408],
              [1884, 8365],
              [1845, 8318],
              [1769, 8248],
              [1728, 8198],
              [1747, 8121],
              [1746, 8051],
              [1734, 8029],
              [1741, 7971],
              [1737, 7935],
              [1781, 7883],
              [1763, 7829],
              [1755, 7695],
              [1797, 7679],
              [1868, 7621],
              [1842, 7585],
              [1854, 7537],
              [1840, 7521],
              [1853, 7458],
              [1850, 7431],
              [1866, 7417],
              [1914, 7412],
              [1980, 7365],
              [2004, 7299],
              [1998, 7285],
              [1953, 7298],
              [1936, 7258],
              [1936, 7210],
              [1886, 7224],
              [1854, 7193],
              [1827, 7197],
              [1788, 7229],
              [1741, 7236],
              [1710, 7221],
              [1710, 7202],
              [1681, 7163],
              [1621, 7180],
              [1538, 7162],
              [1506, 7210],
              [1470, 7237],
              [1455, 7277],
              [1392, 7253],
              [1340, 7282],
              [1303, 7279],
              [1283, 7193],
              [1240, 7143],
              [1226, 7195],
              [1160, 7246],
              [1157, 7274],
              [1128, 7280],
              [1116, 7257],
              [1109, 7162],
              [1066, 7143],
              [999, 7089],
              [958, 7077],
              [931, 7082],
              [880, 7117],
              [827, 7112],
              [800, 7095],
              [770, 7120],
              [718, 7135],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "MY.ME",
        properties: {
          "hc-group": "admin1",
          "hc-middle-x": 0.56,
          "hc-middle-y": 0.43,
          hc_key: "my-me",
          "hc-a2": "ME",
          labelrank: "7",
          hasc: "MY.ME",
          "alt-name": "Malacca|Malaka",
          "woe-id": "2346299",
          subregion: null,
          fips: "MY04",
          "postal-code": "ME",
          name: "Melaka",
          country: "Malaysia",
          "type-en": "State",
          region: null,
          longitude: "102.293",
          "woe-name": "Melaka",
          latitude: "2.32162",
          "woe-label": "Melaka, MY, Malaysia",
          type: "State",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [1931, 4951],
              [1886, 4927],
              [1851, 4880],
              [1853, 4855],
              [1834, 4802],
              [1833, 4765],
              [1813, 4743],
              [1819, 4721],
              [1867, 4702],
              [1862, 4655],
              [1837, 4652],
              [1820, 4625],
              [1519, 4748],
              [1458, 4789],
              [1383, 4872],
              [1350, 4882],
              [1318, 4908],
              [1320, 4922],
              [1352, 4940],
              [1378, 4968],
              [1392, 4958],
              [1406, 4990],
              [1439, 4987],
              [1481, 4998],
              [1515, 5022],
              [1558, 5002],
              [1607, 4994],
              [1675, 5017],
              [1715, 5018],
              [1788, 4985],
              [1931, 4951],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "MY.NS",
        properties: {
          "hc-group": "admin1",
          "hc-middle-x": 0.52,
          "hc-middle-y": 0.57,
          hc_key: "my-ns",
          "hc-a2": "NS",
          labelrank: "7",
          hasc: "MY.NS",
          "alt-name": "Negeri Sembilan Darul Khusus|Negri Sembilan",
          "woe-id": "2346300",
          subregion: null,
          fips: "MY05",
          "postal-code": "NS",
          name: "Negeri Sembilan",
          country: "Malaysia",
          "type-en": "State",
          region: null,
          longitude: "102.149",
          "woe-name": "Negeri Sembilan",
          latitude: "2.70857",
          "woe-label": "Negeri Sembilan, MY, Malaysia",
          type: "State",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [2037, 5366],
              [2032, 5336],
              [1966, 5162],
              [1974, 5137],
              [1954, 5099],
              [1952, 5014],
              [1931, 4951],
              [1788, 4985],
              [1715, 5018],
              [1675, 5017],
              [1607, 4994],
              [1558, 5002],
              [1515, 5022],
              [1481, 4998],
              [1439, 4987],
              [1406, 4990],
              [1392, 4958],
              [1378, 4968],
              [1352, 4940],
              [1320, 4922],
              [1258, 4953],
              [1209, 4940],
              [1196, 4926],
              [1182, 5010],
              [1135, 5049],
              [1115, 5106],
              [1093, 5123],
              [1053, 5126],
              [1070, 5197],
              [1105, 5268],
              [1092, 5392],
              [1116, 5395],
              [1193, 5387],
              [1221, 5410],
              [1233, 5463],
              [1264, 5494],
              [1272, 5539],
              [1297, 5565],
              [1289, 5617],
              [1295, 5662],
              [1277, 5714],
              [1280, 5741],
              [1263, 5781],
              [1250, 5787],
              [1267, 5810],
              [1343, 5752],
              [1390, 5740],
              [1399, 5700],
              [1458, 5721],
              [1513, 5699],
              [1638, 5658],
              [1722, 5644],
              [1799, 5556],
              [2001, 5419],
              [2020, 5423],
              [2037, 5366],
            ],
          ],
        },
      },
      {
        type: "Feature",
        id: "MY.TE",
        properties: {
          "hc-group": "admin1",
          "hc-middle-x": 0.49,
          "hc-middle-y": 0.42,
          hc_key: "my-te",
          "hc-a2": "TE",
          labelrank: "7",
          hasc: "MY.TE",
          "alt-name": "Terengganu Darul Iman",
          "woe-id": "2346307",
          subregion: null,
          fips: "MY13",
          "postal-code": "TE",
          name: "Terengganu",
          country: "Malaysia",
          "type-en": "State",
          region: null,
          longitude: "103.013",
          "woe-name": "Trengganu",
          latitude: "4.94214",
          "woe-label": "Terengganu, MY, Malaysia",
          type: "State",
        },
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [1998, 7285],
              [2004, 7299],
              [1980, 7365],
              [1914, 7412],
              [1866, 7417],
              [1850, 7431],
              [1853, 7458],
              [1840, 7521],
              [1854, 7537],
              [1842, 7585],
              [1868, 7621],
              [1797, 7679],
              [1755, 7695],
              [1763, 7829],
              [1781, 7883],
              [1737, 7935],
              [1741, 7971],
              [1734, 8029],
              [1746, 8051],
              [1747, 8121],
              [1728, 8198],
              [1769, 8248],
              [1845, 8318],
              [1884, 8365],
              [1945, 8326],
              [1987, 8283],
              [2010, 8236],
              [2037, 8223],
              [2215, 8082],
              [2258, 8061],
              [2299, 8053],
              [2366, 7996],
              [2458, 7892],
              [2560, 7733],
              [2594, 7648],
              [2693, 7483],
              [2751, 7377],
              [2784, 7309],
              [2777, 7279],
              [2788, 7215],
              [2804, 7065],
              [2786, 7004],
              [2796, 6945],
              [2828, 6853],
              [2831, 6823],
              [2815, 6777],
              [2786, 6742],
              [2789, 6700],
              [2777, 6687],
              [2753, 6695],
              [2680, 6698],
              [2655, 6712],
              [2659, 6669],
              [2642, 6628],
              [2641, 6584],
              [2658, 6569],
              [2657, 6532],
              [2677, 6476],
              [2672, 6447],
              [2637, 6411],
              [2613, 6450],
              [2613, 6472],
              [2571, 6538],
              [2548, 6534],
              [2535, 6559],
              [2511, 6555],
              [2450, 6607],
              [2401, 6632],
              [2328, 6651],
              [2274, 6628],
              [2238, 6656],
              [2252, 6680],
              [2269, 6791],
              [2296, 6838],
              [2321, 6855],
              [2347, 6854],
              [2361, 6917],
              [2345, 6960],
              [2302, 6994],
              [2285, 6973],
              [2224, 6987],
              [2187, 7028],
              [2180, 7064],
              [2203, 7086],
              [2217, 7129],
              [2208, 7165],
              [2181, 7192],
              [2103, 7197],
              [2028, 7234],
              [1998, 7285],
            ],
          ],
        },
      },
      {
        type: "Feature",
        properties: {
          "hc-group": "__separator_lines__",
        },
        geometry: {
          type: "LineString",
          coordinates: [
            [4350, 9600],
            [4350, 3450],
          ],
        },
      },
    ],
  };
}

export default { load_data };
